module.exports = __webpack_public_path__ + "img/img3.e75d1f44.png";